import * as yup from 'yup'

const ControleFormScheme = {
  start: yup.object().shape({}),
  presta: yup.object().shape({
    societeId: yup.string().required('errors.form.empty'),
  }),
  nature: yup.object().shape({
    nature: yup.string().required('errors.form.empty'),
  }),
  manif: yup.object().shape({
    manifestationId: yup.string().required('errors.form.empty'),
  }),
  period: yup.object().shape({
    period: yup.string().required('errors.form.empty'),
  }),
  metier: yup.object().shape({
    metierId: yup.string().required('errors.form.empty'),
  }),
  spaces: yup.object().shape({
    localisationIds: yup.array().of(yup.string()).min(1),
  }),
  type: yup.object().shape({
    accompagnementPrestataire: yup.boolean().required('errors.form.empty'),
  }),
  questions: yup.object().shape({
    reponses: yup.array().of(
      yup.object().shape({
        questionId: yup.string().required(),
        localisationId: yup.string().required(),
        conformite: yup.string().required(),
        commentaire: yup.string().when(['conformite'], {
          is: (conformite: 'CONFORME' | 'NON_CONFORME_MINEUR' | 'NON_CONFORME_MAJEUR' | 'NON_CONCERNE') =>
            conformite === 'NON_CONFORME_MINEUR' || conformite === 'NON_CONFORME_MAJEUR',
          then: yup.string().required('errors.form.empty'),
          otherwise: yup.string(),
        }),
      })
    ),
    completed: yup.boolean().required().equals([true]),
  }),
  info: yup.object().shape({
    commentaire: yup.string(),
  }),
  recap: yup.object().shape({}),
}

const ControleFormFields: { [key in ControleStep]: (keyof ControleForm)[] } = {
  start: ['id'],
  presta: ['societeId'],
  nature: ['nature'],
  manif: ['manifestationId'],
  period: ['period'],
  metier: ['metierId'],
  spaces: ['localisationIds'],
  type: ['accompagnementPrestataire'],
  questions: ['reponses'],
  info: ['commentaire'],
  recap: [],
}

export { ControleFormScheme, ControleFormFields }
